(function () {
  'use strict'

  /**
     * @ngdoc module
     * @name ThismomentExpandedContent
     * @module thismoment.expandedContent.core
     *
     * @description
     * A component that shows the big view of the cards and is shared with playlists; an extension of modal
     */

  var MODULE_NAME = 'thismoment.expandedContent.core'
  var templateUrl = require('./tpl/expanded-content.html')
  // windowTemplateUrl = require('./tpl/expanded-content-window.html')

  require('dynamic-bind-html') // ಠ_ಠ
  require('angular-base64')

  require('angular')
    .module(MODULE_NAME, [
      'dynamicBindHtml',
      'base64',
      require('../analytics'),
      require('../common/component/video'),
      require('../common/component/video-facebook'),
      require('../common/component/video-youtube.js'),
      require('../modal')
    ])
  // TODO: Move ExpandedContentService to own file.
    .service('ExpandedContent', ExpandedContentService)
  // TODO: Move thismomentExpandedContent to own file.
    .component('thismomentExpandedContent', {
      bindings: {
        resolve: '<',
        close: '&'
      },
      templateUrl: templateUrl,
      controller: expandedContentController
    })

  ExpandedContentService.$inject = ['$rootScope', 'Modal']
  function ExpandedContentService ($rootScope, Modal) {
    this.open = openExpandedContent

    function openExpandedContent (item, options, success, cancel) {
      var cardClasses = [
        'content-id-' + item.id.toString(),
        item.source.source_name || '',
        item.class_name || '',
        item.type_name || '',
        options.layout || ''
      ]
      $rootScope.modalOpen = true
      var expanded = Modal()
      expanded.open(
        {
          animation: options.animation || false,
          component: 'thismomentExpandedContent',
          resolve: {
            item: item,
            options: options
          },
          ariaDescribedby: 'modal-description',
          ariaLabelledBy: 'modal-description',
          windowTopClass: cardClasses.join(' ')
        },
        success,
        cancel
      )()
    }
  }

  expandedContentController.$inject = ['$rootScope', '$sce', '$base64', 'SdkConfig', 'analyticsSDK']
  function expandedContentController ($rootScope, $sce, $base64, SdkConfig, analyticsSDK) {
    const vm = this
    var className
    var isDocument
    var isImage
    var isPdf
    var isVideo
    var sourceName
    var typeName

    vm.$onInit = expandedContentInit
    $rootScope.modalClose = expandedContentClose

    function expandedContentInit () {
      const item = vm.resolve.item
      vm.embedCode = embedCode

      vm.item = vm.resolve.item
      vm.analyticsProps = analyticsSDK.mapContentProps(vm.item)
      vm.options = vm.resolve.options

      vm.kioskMode = vm.options.kioskMode
      vm.showBlur = vm.kioskMode

      vm.trackEvent = analyticsSDK.setupEventTracking(vm.analyticsProps)
      vm.trackEvent('Content Expanded', {'event trigger': 'clicked content'})

      /*
       * TODO:
       * Right now the rest of this function is near identical to `card.js`
       * In the future `card` should pass a fully formed 'display content object'
       * to `expanded` which can then override where necessary.
       */
      /** ********* Determine HOW is it displayed START ***********/
      vm.styles = {
        main: {},
        title: {},
        description: {},
        date: {},
        source: {},
        icon: {}
      }
      vm.classes = {
        card: {}
      }

      // if (vm.options.hasOwnProperty('card_border_shape'))
      //     vm.classes.modal.rounded = (vm.options.card_border_shape === 'rounded')
      // if (vm.options.hasOwnProperty('card_border_color'))
      //     vm.styles.main['border-color'] = vm.options.card_border_color
      if (Object.prototype.hasOwnProperty.call(vm.options, 'card_background_color')) {
        vm.styles.main['background-color'] = vm.options.card_background_color
      }
      if (Object.prototype.hasOwnProperty.call(vm.options, 'card_title_font_color')) {
        vm.styles.title.color = vm.options.card_title_font_color
      }
      if (Object.prototype.hasOwnProperty.call(vm.options, 'card_description_font_color')) {
        vm.styles.description.color = vm.options.card_description_font_color
      }
      if (Object.prototype.hasOwnProperty.call(vm.options, 'card_date_font_color')) {
        vm.styles.date.color = vm.options.card_date_font_color
      }
      if (Object.prototype.hasOwnProperty.call(vm.options, 'card_source_font_color')) {
        vm.styles.source.color = vm.options.card_source_font_color
      }
      if (Object.prototype.hasOwnProperty.call(vm.options, 'card_icon_color')) {
        vm.styles.icon.color = vm.options.card_icon_color
      }

      sourceName = item.source.source_name
      vm.classes.card[sourceName] = (sourceName)

      className = item.class_name
      vm.classes.card[className] = (className)

      typeName = item.type_name
      vm.classes.card[typeName] = (typeName)
      /** ********* Determine HOW is it displayed END ***********/

      /** ********* Determine WHAT is displayed START ***********/
      var cardBools = [
        'card_source_display',
        'card_source_display',
        'card_cart_display',
        'card_date_display',
        'card_description_display',
        'card_media_display',
        'card_share_display',
        'card_title_display'
      ]

      angular.forEach(cardBools, function (value) {
        if (!Object.prototype.hasOwnProperty.call(vm.options, value)) {
          vm.options[value] = true
        }
      })

      // apps handle themselves.
      if (className === 'app') {
        if (typeName === 'html') {
          vm.isHtml = true
          return
        }
        if (typeName === 'mva-embed') {
          vm.isMvaEmbed = true
          return
        }
        if (typeName === 'text-a-playlist') {
          vm.isTextPlaylist = true
          return
        }
        if (typeName === 'vcard-dynamic') {
          vm.isVcardDynamic = true
          return
        }
        if (typeName === 'vcard-image-promo') {
          vm.isVcardImagePromo = true
          return
        }
        if (typeName === 'vcard-static') {
          vm.isVcardStatic = true
          return
        }
        if (typeName === 'event-dynamic') {
          vm.isEventDynamic = true
          return
        }
      }

      // default template values
      vm.allowHtml = !item.is_ugc
      vm.altText = item.alt_text
      vm.analyticsTrigger = 'Content source viewed'
      vm.ariaLabel = item.title || item.description_ptf || item.alt_text
      vm.author = item.source.author
      vm.avatar = item.source.avatar_url || item.source.favicon_url
      vm.avatarAltText = 'An avatar for ' + sourceName + ' user ' + vm.author
      vm.contentId = item.id
      vm.description = (item.is_ugc) ? item.description_ptf.replace(/(<br \/>\s*)+$/g, '') : item.description.replace(/(<br \/>\s*)+$/g, '')
      vm.displayDescription = true
      vm.displayLinkIcon = true
      vm.displayTitle = true
      vm.sourceLinkAriaLabel = 'View the original ' + sourceName + ' content at ' + item.source.post_url
      vm.sourceSize = item.source.size
      vm.sourceUrl = item.source.post_url
      vm.timestamp = item.added_timestamp
      vm.title = item.title
      vm.username = '@' + item.source.username

      if (className === 'text') {
        vm.imageSrc = null
        vm.timestamp = item.added_timestamp
      } else {
        // use the large if we don't have widths available; if we have the widths, use large only if it is greater than 350px wide
        vm.imageSrc = (isNaN(item.images.large.width) || item.images.large.width === null) ? item.images.large.url : (item.images.large.width > 500) ? item.images.large.url : item.images.original.url
      }

      /*
      OK, this is ugly... I get it. But it's way easier to maintain
      when it's like this than when everything's done in one huge
      logical clusterfuck. Believe me, I'm not thrilled with it, either.

      Display parameters that can't be true for a given card type are
      omitted for brevity and default values are overridden below where
      necessary.

      If you can make it prettier, by all means, be my guest. -NS
      */
      switch (sourceName) {
        case 'youtube':
          vm.ytId = item.source.origin_id
          vm.ytUrl = item.videos.large.url
          vm.ytImg = item.images.original.url

          vm.displayAuthor = false
          vm.displayAvatar = false
          vm.displayImage = false
          vm.displayYoutube = true
          break

        case 'facebook':
          isImage = (className === 'image')
          isVideo = (className === 'video')

          vm.displayAuthor = (vm.author)
          vm.displayDateAdded = true
          vm.displayDescription = (item.description)
          vm.displayImage = vm.imageSrc && isImage
          vm.displayImageAriaLabel = 'View this facebook post at full size'
          vm.displayTitle = (item.title && !vm.kioskMode)
          vm.displayFacebookVideo = isVideo
          break

        case 'instagram':
          isImage = (className === 'image')
          isVideo = (className === 'video')

          vm.displayAuthor = (vm.author)
          vm.displayAvatar = (vm.avatar)
          vm.displayDateAdded = true
          vm.displayImage = vm.imageSrc && isImage
          vm.displayImageAriaLabel = 'View this instagram image at full size'
          vm.displayVideo = isVideo
          break

        case 'linkedin':
          isImage = (className === 'image')

          vm.username = null
          vm.displayAuthor = vm.kioskMode ? false : (vm.author)
          vm.displayAvatar = vm.kioskMode ? false : (vm.avatar)
          vm.displayDateAdded = true
          vm.displayDescription = (!vm.kioskMode && item.description)
          vm.displayImage = vm.imageSrc && isImage
          vm.displayLinkIcon = true
          vm.displayTitle = (!vm.kioskMode && item.title)
          break

        case 'publishthis':
          vm.author = item.source.username
          vm.username = null

          vm.displayAuthor = (vm.author)
          vm.displayAvatar = (vm.avatar)
          vm.displayDateAdded = true
          vm.displayImage = (vm.imageSrc)
          vm.displayImageAriaLabel = 'View full article'
          break

        case 'thismoment':
        case 'thismoment-app':
          switch (className) {
            case 'text':
              if (vm.options.card_user_display) {
                if (!angular.isDefined(vm.item.extended[vm.options.card_user_firstname_key])) {
                  vm.item.extended[vm.options.card_user_firstname_key] = ''
                }
                if (!angular.isDefined(vm.item.extended[vm.options.card_user_lastname_key])) {
                  vm.item.extended[vm.options.card_user_lastname_key] = ''
                }
                vm.author = vm.item.extended[vm.options.card_user_firstname_key] + ' ' + vm.item.extended[vm.options.card_user_lastname_key]
                vm.username = ''
              }
              vm.classes.title = {
                'text-center': vm.kioskMode
              }
              break

            case 'app':
              vm.analyticsTrigger = 'clicked promo'
              vm.imageSrc = item.images.large.url
              vm.sourceUrl = SdkConfig.get('content_cloud_url') + '/api/export/v1/download-media?resource=' + $base64.encode(item.images.original.url)
              vm.imagePromoLink = item.app.url
              vm.imagePromoTarget = item.app.target

              vm.displayImagePromo = (vm.imageSrc)
              vm.displayImageAriaLabel = (vm.imagePromoLink) ? 'Go to ' + vm.imagePromoLink : 'View this image'

              vm.classes.imagePromo = {
                'no-link': !vm.imagePromoLink
              }
              break

            case 'image':
              isImage = true
              vm.sourceUrl = SdkConfig.get('content_cloud_url') + '/api/export/v1/download-media?resource=' + $base64.encode(item.images.original.url)
              vm.hideMain = vm.kioskMode ? !item.description.trim() && !item.title.trim() : false

              if (angular.isObject(item.app) && 'url' in item.app && item.app.url !== '') {
                vm.analyticsTrigger = 'clicked promo'
                vm.imagePromoTarget = '_blank'
                vm.imagePromoLink = item.app.url
                vm.displayImagePromo = (vm.imageSrc)
                vm.displayImageAriaLabel = (vm.imagePromoLink) ? 'Go to ' + vm.imagePromoLink : 'View this image'
              }

              if (vm.options.card_user_display) {
                if (!angular.isDefined(vm.item.extended[vm.options.card_user_firstname_key])) {
                  vm.item.extended[vm.options.card_user_firstname_key] = ''
                }
                if (!angular.isDefined(vm.item.extended[vm.options.card_user_lastname_key])) {
                  vm.item.extended[vm.options.card_user_lastname_key] = ''
                }
                vm.author = vm.item.extended[vm.options.card_user_firstname_key] + ' ' + vm.item.extended[vm.options.card_user_lastname_key]
                vm.username = ''
              }
              break

            case 'video':
              isVideo = true
              vm.sourceUrl = SdkConfig.get('content_cloud_url') + '/api/export/v1/download-media?resource=' + $base64.encode(item.videos.original.url)
              vm.displayImageAriaLabel = 'Play this video'
              vm.displayLinkIcon = false
              vm.displayFavicon = false
              vm.hideMain = vm.kioskMode ? !item.description.trim() && !item.title.trim() : false
              if (vm.options.card_user_display) {
                if (!angular.isDefined(vm.item.extended[vm.options.card_user_firstname_key])) {
                  vm.item.extended[vm.options.card_user_firstname_key] = ''
                }
                if (!angular.isDefined(vm.item.extended[vm.options.card_user_lastname_key])) {
                  vm.item.extended[vm.options.card_user_lastname_key] = ''
                }
                vm.author = vm.item.extended[vm.options.card_user_firstname_key] + ' ' + vm.item.extended[vm.options.card_user_lastname_key]
                vm.username = ''
              }
              break

            case 'document':
              isDocument = true
              vm.sourceUrl = SdkConfig.get('content_cloud_url') + '/api/export/v1/download-media?resource=' + $base64.encode(item.source.post_url)
              vm.analyticsTrigger = 'downloaded/viewed file'
              vm.username = ''
              vm.displayImageAriaLabel = 'Open expanded version of this document'

              // Set classes, avatar, and author based on filetype
              switch (getFileExt()) {
                case 'xls':
                case 'xlsx':
                  vm.classes.card.excel = true
                  vm.avatar = require('../common/assets/img/icn-file-xls.png')
                  vm.author = 'Microsoft Excel'
                  break

                case 'ppt':
                case 'pptx':
                  vm.classes.card.presentation = true
                  vm.avatar = require('../common/assets/img/icn-file-ppt.png')
                  vm.author = 'Microsoft PowerPoint'
                  break

                case 'doc':
                case 'docx':
                  vm.classes.card.doc = true
                  vm.avatar = require('../common/assets/img/icn-file-doc.png')
                  vm.author = 'Microsoft Word'
                  break

                case 'pdf':
                  vm.classes.card.pdf = true
                  vm.avatar = require('../common/assets/img/icn-file-pdf.png')
                  vm.author = 'Adobe PDF'
                  isPdf = true
                  break
              }
              break
          }
          vm.favicon = vm.options.favicon
          vm.displayAuthor = (vm.author)
          vm.displayAvatar = (vm.avatar)
          vm.displayDateAdded = isDocument
          vm.displayFileSize = isDocument
          vm.displayImage = vm.imageSrc && !vm.displayImagePromo && (isPdf || isImage)
          vm.displayLinkedTitle = (isDocument && vm.title)
          vm.displayLinkIcon = (vm.options.card_media_download && !vm.kioskMode)
          vm.displayTitle = vm.title && (vm.displayImagePromo || !isDocument)
          vm.displayVideo = isVideo
          vm.displayFavicon = (vm.favicon && vm.kioskMode)
          break

        case 'twitter':
          isImage = (className === 'image')
          isVideo = (className === 'video')

          vm.displayAuthor = (vm.author)
          vm.displayAvatar = (vm.avatar)
          vm.displayDateAdded = true
          vm.displayImage = vm.imageSrc && isImage
          vm.displayVideo = isVideo
          break

        default:
          var descriptionLimiter = Math.round(item.description.length / 300)
          if (descriptionLimiter < 4) {
            vm.sizeClass = 'size-' + descriptionLimiter
          } else {
            // Modal is maxed at 92.5vh, quote marks take up additional 225 px, each line takes up 30px
            // This determines the number of lines that can fit before needing clamping
            vm.styles.description['-webkit-line-clamp'] = Math.floor(((window.innerHeight * 0.925) - 225) / 30)
            vm.sizeClass = 'size-' + descriptionLimiter + ' truncate'
          }
          vm.displayLinkIcon = false
          break
      }

      // overrides from `card_options`
      vm.displayAuthor = (vm.options.card_source_display && vm.displayAuthor)
      vm.displayAvatar = (vm.options.card_source_display && vm.displayAvatar)
      vm.displayCart = vm.options.card_cart_display
      vm.displayVote = ('card_vote_display' in vm.options) ? vm.options.card_vote_display.contestActive : false
      vm.displayDateAdded = vm.options.card_date_display
      vm.displayDescription = (vm.options.card_description_display && vm.displayDescription)
      vm.displayMedia = vm.options.card_media_display
      vm.displayShare = (vm.options.card_share_display && !vm.kioskMode)
      vm.displayTitle = (vm.options.card_title_display && vm.displayTitle)
      vm.displayLinkedTitle = (vm.options.card_title_display && vm.displayLinkedTitle)

      // final component logic
      vm.displayFooter = vm.displayMeta || vm.displayShare
      vm.displayMain = vm.hideMain ? false : vm.displayLinkIcon || vm.displayTitle || vm.displayLinkedTitle || vm.displayDescription || vm.displayDateAdded || vm.displayFileSize || vm.displayFooter || vm.displayCart
      vm.displayMedia = vm.displayMedia && (vm.displayImagePromo || vm.displayImage || vm.displayVideoOverlay || vm.displayTwitterKiosk || vm.displayYoutube || vm.displayFacebookVideo || vm.displayVideo)
      vm.displayMeta = vm.displayAvatar || vm.displayAuthor
      vm.displayLinkIconOnly = ((!vm.title || vm.title.trim() === '') && (!vm.description || vm.description.trim() === '')) && (!vm.item.extended.name_public || vm.item.extended.name_public === '') && (vm.displayLinkIcon || vm.displayFavicon)
      vm.hideBody = !vm.displayTitle &&
        !vm.displayDescription &&
        (!vm.item.extended.name_public || vm.item.extended.name_public === '') &&
        !vm.options.card_date_display &&
        !vm.options.card_source_display &&
        !vm.options.card_share_display
      /** ********* Determine WHAT is displayed END ***********/

      function getFileExt () {
        var extArry = item.source.post_url.split('/')
        var fileExt = extArry[extArry.length - 1].split('.')

        return fileExt[fileExt.length - 1]
      }
    }

    function expandedContentClose () {
      vm.close()
      $rootScope.modalOpen = false
    }

    function embedCode (embed) {
      return $sce.trustAsHtml(embed.embed_code)
    }
  }

  module.exports = MODULE_NAME
})()



// WEBPACK FOOTER //
// ./src/expandedContent/expanded-content.js